module.exports = __webpack_public_path__ + "img/service-3.e6e90077.svg";